import {
  BaseEntityDto,
  GeneralStatusMetaTypedDtoOfAvailabilityStatus,
} from "@/core/api/generated/v1";

import GeneralStatusMetaDisplay, {
  GeneralStatusMetaDisplayProps,
} from "./GeneralStatusMetaDisplay";
import { AvailabilityStatusDisplay } from "./Statuses/AvailabilityStatusDisplay";

interface Props {
  value: GeneralStatusMetaTypedDtoOfAvailabilityStatus | undefined | null;
  subjectEntity: BaseEntityDto | undefined;
  statusDisplayProps?: Partial<GeneralStatusMetaDisplayProps>;
  onMetaUpdated: (newValue: GeneralStatusMetaTypedDtoOfAvailabilityStatus) => void;
}

export default function GeneralStatusMetaDisplayOfAvailabilityStatus({
  value,
  subjectEntity,
  statusDisplayProps,
  onMetaUpdated,
}: Props) {
  if (!value) {
    return null;
  }

  return (
    <GeneralStatusMetaDisplay
      value={value}
      subjectEntity={subjectEntity}
      mainContent={<AvailabilityStatusDisplay status={value.statusTyped} />}
      onMetaUpdated={(newValue) => {
        onMetaUpdated({ ...value, ...newValue });
      }}
      {...statusDisplayProps}
    />
  );
}
